import TextInput from "Components/molecule/inputs/text-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import { CSSProperties } from "react"
import FormProps from "data/forms"
import ResetPasswordFields from "./types"

interface ResetPasswordFormProps extends FormProps<ResetPasswordFields> {
    style?: CSSProperties
}

const OLD_PASSWORD_KEY = 'oldPassword'; 
const NEW_PASSWORD_KEY = 'newPassword';
const CONFIRM_PASSWORD_KEY = 'confirmPassword';

const ResetPasswordForm = ({
    style,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    values,
    isSubmitting,
    isValid,
    touched
}: ResetPasswordFormProps) => {
    return (
        <div className="reset-password-form-container" style={style}>
            <div className="reset-password-fields">

                <TextInput
                    label={"Old Password"}
                    type="password"
                    placeholder="Old password"
                    name={OLD_PASSWORD_KEY}
                    key={OLD_PASSWORD_KEY}
                    touched={!!touched.oldPassword}
                    value={values.oldPassword}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.oldPassword && !!errors.oldPassword}
                    message={errors.oldPassword}
                />

                <TextInput
                    label={"New Password"}
                    type="password"
                    placeholder="New password"
                    name={NEW_PASSWORD_KEY}
                    key={NEW_PASSWORD_KEY}
                    touched={!!touched.newPassword}
                    value={values.newPassword}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.newPassword && !!errors.newPassword}
                    message={errors.newPassword}
                />

                <TextInput
                    label={"Confirm New Password"}
                    type="password"
                    placeholder="Confirm new password"
                    name={CONFIRM_PASSWORD_KEY}
                    key={CONFIRM_PASSWORD_KEY}
                    touched={!!touched.confirmPassword}
                    value={values.confirmPassword}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.confirmPassword && !!errors.confirmPassword}
                    message={errors.confirmPassword}
                />

            </div>

            <div className="reset-password-submit-button">
                <PrimaryButton onClick={() => handleSubmit()} disabled={!isValid || isSubmitting}>
                    {isSubmitting ? 'Updating...' : 'Update Password'}
                </PrimaryButton>
            </div>
        </div>
    )
}

export default ResetPasswordForm
